import View from './base';

export default View.extend( {
	tagName: 'a',

	events: {
		'click': 'select',
	},

	select: function() {
		this.trigger( 'select' );
	},

	renderTriggerLink: function() {
		this.$el.attr( 'href', this.getTriggerLink() );
	},
} );
